/**
 * Home - messages
 */

import { defineMessages } from 'react-intl'

export default defineMessages({
  helpFind: {
    id: 'screens.Home.help.find',
    // tslint:disable-next-line:quotemark
    defaultMessage: "Not sure? We'll help you find out."
  },
  startButton: {
    id: 'screens.Home.start.button',
    defaultMessage: 'GET STARTED'
  },
  flexibleLabel: {
    id: 'screens.Home.flexibleLabel',
    defaultMessage: 'FLEXIBLE DESIGN OPTIONS'
  },
  collectionOrCustom: {
    id: 'screens.Home.collectionOrCustom',
    defaultMessage: 'COLLECTION OR CUSTOM'
  },
  fastDeliveryLabel: {
    id: 'screens.Home.fastDelivery',
    defaultMessage: 'FAST DELIVERY'
  },
  twoWeeksOrLess: {
    id: 'screens.Home.twoWeeksOrLess',
    defaultMessage: '2 WEEKS OR LESS'
  },
  teamStores: {
    id: 'screens.Home.teamStores',
    defaultMessage: 'TEAM STORES'
  },
  getStarted: {
    id: 'screens.Home.getStarted',
    defaultMessage: `I'M INTERESTED, AND I WOULD LIKE MORE INFORMATION`
  },
  easyLabel: {
    id: 'screens.Home.easyLabel',
    defaultMessage: 'EASY ORDERING'
  },
  priceDrop: {
    id: 'screens.Home.priceDrop',
    defaultMessage: 'SAVE WITH DYNAMIC PRICE DROP'
  },
  orderDate: {
    id: 'screens.Home.orderDate',
    defaultMessage: 'ORDER DATE'
  },
  deliveryDate: {
    id: 'screens.Home.deliveryDate',
    defaultMessage: 'DELIVERY DATE'
  },
  redirectMessage: {
    id: 'screens.Home.redirectMessage',
    defaultMessage: 'You are being redirected, please wait...'
  },
  currentTurnaround: {
    id: 'screens.Home.currentTurnaround',
    defaultMessage: 'Current turnaround time for full custom kits'
  },
  days: {
    id: 'screens.Home.days',
    defaultMessage: 'DAYS'
  },
  orderingNote: {
    id: 'screens.Home.orderingNote',
    defaultMessage:
      '*Based on On Demand ordering, and excluding Federal Holidays'
  },
  orLabel: {
    id: 'screens.Home.orLabel',
    defaultMessage: 'OR'
  },
  orText: {
    id: 'screens.Home.orText',
    defaultMessage: `I'm ready to start designing our team kit`
  },
  convenienceTitle: {
    id: 'screens.Home.convenienceTitle',
    defaultMessage: 'CONVENIENCE. VALUE. FLEXIBILITY'
  },
  convenienceText: {
    id: 'screens.Home.convenienceText',
    defaultMessage: `See why 1000's of teams are choosing JAKROO as their provider`
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Home/messages.ts